import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { StandaloneSuccess } = await import('./index');
    return {
        Component: StandaloneSuccess,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
